import { createFileRoute } from "@tanstack/react-router";

import GameSessionDetailsPage from "~/pages/gameSession/GameSessionDetailsPage.tsx";

export const Route = createFileRoute("/_auth/game-session/$gameSessionId/")({
    component: GameSessionDetailsPage,
});
